import WebFontLoader from "webfontloader";
export default {
    data() {
        return {
            countries: {},
            currencies: {},
            timezones: {},
            fonts: {},
            colors: {},
            cuisines: {},
            states: {},
        };
    },
    methods: {
        getCountries() {
            return new Promise((resolve, reject) => {
                axios.get("/api/countries").then(
                    (response) => {
                        if (response.data) {
                            this.countries = response.data;
                            resolve(response.data);
                        }
                    },
                    (error) => {
                        console.log(error.response.data);
                    }
                );
            });
        },
        getStates(country_id) {
            return new Promise((resolve, reject) => {
                axios.get("/api/states/" + country_id).then(
                    (response) => {
                        if (response.data) {
                            this.states = response.data;
                            resolve(response.data);
                        }
                    },
                    (error) => {
                        console.log(error.response.data);
                    }
                );
            });
        },
        getStatesDirectoryActive(country_id) {
            return new Promise((resolve, reject) => {
                axios.get("/api/states/directory-active/" + country_id).then(
                    (response) => {
                        if (response.data) {
                            this.states = response.data;
                            resolve(response.data);
                        }
                    },
                    (error) => {
                        console.log(error.response.data);
                    }
                );
            });
        },
        getCities(state_id) {
            return new Promise((resolve, reject) => {
                axios.get("/api/cities/" + state_id).then(
                    (response) => {
                        if (response.data) {
                            this.cities = response.data;
                            resolve(response.data);
                        }
                    },
                    (error) => {
                        console.log(error.response.data);
                    }
                );
            });
        },
        getNeighborhoods(state_id, city_slug) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/neighborhoods/" + state_id + "/" + city_slug)
                    .then(
                        (response) => {
                            if (response.data) {
                                this.neighborhoods = response.data;
                                resolve(response.data);
                            }
                        },
                        (error) => {
                            console.log(error.response.data);
                        }
                    );
            });
        },
        getCurrencies() {
            axios.get("/api/currencies").then(
                (response) => {
                    if (response.data) {
                        this.currencies = response.data;
                    }
                },
                (error) => {
                    console.log(error.response.data);
                }
            );
        },
        getTimezones() {
            axios.get("/api/timezones").then(
                (response) => {
                    if (response.data) {
                        this.timezones = response.data;
                    }
                },
                (error) => {
                    console.log(error.response.data);
                }
            );
        },
        getFonts() {
            return new Promise((resolve, reject) => {
                axios.get("/api/fonts").then(
                    (response) => {
                        if (response.data) {
                            this.fonts = response.data;
                            resolve(response.data);
                        }
                    },
                    (error) => {
                        console.log(error.response.data);
                    }
                );
            });
        },
        getCuisines() {
            axios.get("/api/cuisines").then(
                (response) => {
                    if (response.data) {
                        this.cuisines = response.data;
                    }
                },
                (error) => {
                    console.log(error.response.data);
                }
            );
        },
        loadSystemFonts() {
            return new Promise((resolve, reject) => {
                this.getFonts().then((result) => {
                    if (!this.systemFontsLoaded) {
                        let menuFonts = new Array();
                        _.each(result, function (font) {
                            menuFonts.push(font.name + ":400,700");
                        });

                        WebFontLoader.load({
                            google: {
                                families: menuFonts,
                            },
                            active: this.setFontsLoaded,
                        });
                    }
                    resolve();
                });
            });
        },
        setFontsLoaded() {
            this.setSystemFontsLoaded(true);
        },
    },
};
